<template>
  <div class="all-journeys">
    <b-container>
      <b-row>
        <draggable v-model="Journeys" id="drags" v-bind="dragOptions">
          <Journey
            v-for="(journey, i) in journeys"
            :index="i"
            :key="journey.id"
            :journey="journey"
            @addFocus="addFocus"
            @editJourney="editJourney"
            @archiveJourney="archiveJourney"
          ></Journey>
        </draggable>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Journey from "../journey";
import draggable from "vuedraggable";
export default {
  props: ["journeys"],
  data() {
    return {
      Journeys: this.journeys
    };
  },
  components: {
    Journey,
    draggable
  },
  computed: {
    dragOptions() {
      return {
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    journeys(newval) {
      this.Journeys = newval;
    }
  },
  methods: {
    editJourney(val) {
      this.$emit("editJourney", val);
    },
    archiveJourney(val) {
      this.$emit("archiveJourney", val);
    },
    addFocus(val) {
      this.$emit("addFocus", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.all-journeys {
  height: calc(100vh - 400px);
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #dddddd;
  filter: drop-shadow(6px 6px 20px rgba(20, 36, 74, 0.05));
  &[aria-grabbed="true"] {
    background: #5cc1a6;
    color: #fff;
  }
}

.all-journeys::-webkit-scrollbar {
  width: 10px;
}
.sidebar::-webkit-scrollbar-track:hover {
  background-color: #ddd;
}
.all-journeys::-webkit-scrollbar-thumb {
  // background-color: var(--scroll);
  border-radius: 16px;
  background: #ddd;
}
@media (max-width: 500px) {
  .all-journeys {
    overflow-y: unset;
  }
}
#drags {
  width: 100%;
}
.ghost {
  opacity: 1;
  // background: #c8ebfb;
  // background-color: red;
  // background-color: #fff;
  background: #eee;
  // border: 1px solid #eee;
  box-shadow: 0 0 0 4px #eee;
  // transform: rotate(5deg) !important;
}
</style>
